import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
Vue.use(VueRouter)
const routes = [{
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/',
        name: 'about',
        component: () =>
            import ('../views/About.vue')
    },
    // 学校报名进行中登录
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('../views/login/login.vue')
    },
    // 忘记密码
    {
        path: '/password',
        name: 'Password',
        component: () =>
            import ('../components/Password')
    },
    //学校报名未开始
    {
        path: '/notbegin',
        name: 'notbegin',
        component: () =>
            import ('../components/notbegin.vue')
    },
    //学校报名已关闭
    {
        path: '/close',
        name: 'close',
        component: () =>
            import ('../components/close')
    },
    //学校报名已结束
    {
        path: '/ends',
        name: 'ends',
        component: () =>
            import ('../components/ends.vue')
    },
    // 编辑详情页面
    {
        path: '/edit',
        name: 'edit',
        component: () =>
            import ('../views/edit.vue')
    },
    // achievement成绩
    {
        path: '/achievement',
        name: 'achievement',
        component: () =>
            import ('../views/achievement.vue')
    },
    // 通知书
    {
        path: '/downloads',
        name: 'downloads',
        component: () =>
            import ('../views/downloads.vue')
    },
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router